import { getApi } from "./api_instance";

export const yourProjetsData = async (
  { page, pageSize, filterData, searchQuery },
  dispatch
) => {
  try {
    filterData = JSON.stringify(filterData);
    return await getApi({
      apiUrl: `/projects/api/userprojects?filterData=${filterData}&page=${page}&pageSize=${pageSize}&searchQuery=${searchQuery}`,
      dispatch,
      sendToken: true,
    });
  } catch (error) {
    throw error;
  }
};
